import { render } from "./SkeletonMedia.vue?vue&type=template&id=8246d4d4"
import script from "./SkeletonMedia.vue?vue&type=script&lang=js"
export * from "./SkeletonMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__